








import { createComponent } from '@vue/composition-api';
import store from '@/core/store';
import { useWebPanel } from './hooks';
import webPanelVuexModule from './store';
import LoadingBar from '@sbvr/lbe-component/LoadingBar.vue';
import Icons from '@sbvr/lbe-component/Icons.vue';

export default createComponent({
  name: 'WebPanel',
  components: {
    LoadingBar,
    Icons,
  },
  props: {
    navigation: { type: Array },
    user: { type: Object },
    dropdownItems: { type: Array },
  },
  setup () {
    store.registerModule('webPanel', webPanelVuexModule);
    const { loading } = useWebPanel();
    return {
      loading,
    };
  },
});
